import { FormControl, TextField } from '@mui/material'
import { type Control, Controller, type FieldValues, type Path } from 'react-hook-form'
import type { IntRangeField } from '../../types'

interface IntRangeFeatureInputFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  field: IntRangeField
  label: string
}

export const IntegerInputField = <T extends FieldValues>({ field, label, ...props }: IntRangeFeatureInputFieldProps<T>) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={(form) => (
        <FormControl {...props}>
          <TextField
            id={`int-range-field-${field.name}`}
            label={label}
            type="number"
            required={field.required}
            onChange={form.field.onChange}
            value={form.field.value ?? ''}
          />
        </FormControl>
      )}
    />
  )
}
